import { PropsWithChildren } from 'react';

import { css } from '@compiled/react';

/**
 * A JSX component for the roadmap column.
 * @param param0
 * @returns A roadmap column JSX component.
 */
export const RoadmapColumn = ({
	columnIndex,
	headerId,
	children,
}: RoadmapColumnPropsType & PropsWithChildren) => {
	const isFirstColumn = columnIndex === 0;
	const isSecondColumn = columnIndex === 1;
	const isLastColumn = columnIndex === 3;

	const firstColHeader = css({
		display: 'flex',
		justifyContent: 'start',
		alignItems: 'center',
		padding: '0px 20px',
		backgroundColor: '#F4F5F7',
		textAlign: 'center',
		height: '57px',
		fontFamily:
			'SF UI Text, Charlie Text, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Noto Sans, Ubuntu, Droid Sans, Helvetica Neue, sans-serif',
		fontWeight: 600,
		fontSize: '16px',
		borderBlockEnd: '1px solid #C1C7D0',
	});

	const notFirstColHeader = css({
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		padding: '0px 20px',
		backgroundColor: '#F4F5F7',
		textAlign: 'center',
		height: '57px',
		fontFamily:
			'SF UI Text, Charlie Text, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Noto Sans, Ubuntu, Droid Sans, Helvetica Neue, sans-serif',
		fontWeight: 600,
		fontSize: '16px',
		borderBlockEnd: '1px solid #C1C7D0',
	});

	const firstCol = css({
		maxWidth: '290px',
		overflow: 'hidden',
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		position: 'relative',
		border: '1px solid #C1C7D0',
		borderStartStartRadius: '5px',
		borderEndStartRadius: '5px',
		borderStartEndRadius: '0px',
		borderEndEndRadius: '0px',
		borderInlineEnd: 'none',
		backgroundColor: '#FFFFFF',
	});
	const secondCol = css({
		maxWidth: '205px',
		overflow: 'hidden',
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		position: 'relative',
		border: '1px solid #C1C7D0',
		borderStartStartRadius: '0px',
		borderEndStartRadius: '0px',
		borderStartEndRadius: '0px',
		borderEndEndRadius: '0px',
		borderInlineEnd: 'none',
		backgroundColor: '#F4F5F7',
	});
	const lastCol = css({
		maxWidth: '205px',
		overflow: 'hidden',
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		position: 'relative',
		border: '1px solid #C1C7D0',
		borderStartStartRadius: '0px',
		borderEndStartRadius: '0px',
		borderStartEndRadius: '5px',
		borderEndEndRadius: '5px',
		borderInlineEnd: '1px solid #C1C7D0',
		backgroundColor: '#FFFFFF',
	});
	const noCol = css({
		maxWidth: '205px',
		overflow: 'hidden',
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		position: 'relative',
		border: '1px solid #C1C7D0',
		borderStartStartRadius: '0px',
		borderEndStartRadius: '0px',
		borderStartEndRadius: '0px',
		borderEndEndRadius: '0px',
		borderInlineEnd: 'none',
		backgroundColor: '#FFFFFF',
	});

	return (
		<div
			css={[
				isFirstColumn && firstCol,
				isSecondColumn && secondCol,
				isLastColumn && lastCol,
				!isFirstColumn && !secondCol && !lastCol && noCol,
			]}
		>
			<div
				css={[isFirstColumn && firstColHeader, !isFirstColumn && notFirstColHeader]}
				data-testid={headerId}
			>
				{children}
			</div>
		</div>
	);
};

export interface RoadmapColumnPropsType {
	columnIndex: number;
	headerId: string;
}
